import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import { 
  TypographyColor, 
  TypographyFontFamily, 
  TypographyFontSize 
} from '@design-system/components/atoms/typography/entities/typography.types';
import { endCallWebView } from '@app/modules/core/util/redirect-login';
import { HeaderService } from '@app/modules/core/header/services/header.service';
import { LoginType } from '@app/entities/login-type';
import { UserInfo } from '@app/modules/core/interfaces/user';
import { environment } from '@environment';
import { isEmpty } from '@app/util/util';
import { homeItemDetailRootRoute } from '@home-item-detail/home-item-detail-routing.module';
import { NavigationService } from '@app/services/navigation.service';
import { GlobalFacade } from '@app/global.facade';

@Component({
  selector: 'app-modal-prime',
  templateUrl: './modal-prime.container.html',
  styleUrls: ['./modal-prime.container.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ModalPrimeComponent {

  public readonly fontFamily = TypographyFontFamily;
  public readonly fontColor = TypographyColor;
  public readonly typographySize = TypographyFontSize;

  public readonly icon = Icon;
  public readonly iconColor = IconFillColor;

  @Input() isMobile = false;
  @Input() userInfo: UserInfo;

  constructor(
    public readonly headerService: HeaderService,
    public readonly globalFacade: GlobalFacade,
    private readonly router: Router,
    private readonly navigationService: NavigationService
  ) { }

  get hasUserInfo(): boolean {
    return !isEmpty(this.userInfo);
  }

  public closeWebview(): void {
    const isHomeItemDetailRootRoute = this.router.url.includes(homeItemDetailRootRoute);
    this.isMobile ? (isHomeItemDetailRootRoute ? this.goBack() : endCallWebView()) : this.goBack();
  }

  public forceUserLogin(): void {
    this.headerService.forceUserLogin(LoginType.Anywhere);
  }

  public deepLinkPro(): void {
    if (typeof window !== 'undefined') {
      window.open(
        this.isMobile ? environment.rappipro_deeplink : environment.rappipro_link,
        this.isMobile ? '_self' : '_blank'
      );
    }
  }

  public goBack(): void {
    this.globalFacade.fetchPrimeModal(false);
    this.navigationService.navigateToBack();
  }

}
